import {METEG} from 'shared/js/commonHebrew'
import styleGlobals from 'shared/js/forTextPanel/styleGlobals'

export function generateAbbreviationDisplayText (abbreviation, expansion) {
  return '<' + METEG + abbreviation.replace(/(.)/g, '$1' + METEG) + '>' + METEG + '\u00A0'
                     + expansion.replace(/ /g, styleGlobals.SPACE_SUBSTITUTE)
}
